import React from 'react';
import { motion } from 'framer-motion';
import { HeartHandshakeIcon, InstagramIcon, MailIcon, SproutIcon } from 'lucide-react';
export function Authority() {
  return <section className="bg-brand-cream px-4 py-16 md:py-20" data-id="element-15" data-mp="3updcycm1c9z6">
      <div className="mx-auto grid max-w-5xl items-center gap-10 md:grid-cols-[0.8fr_1.2fr]" data-id="element-16" data-mp="2i6k3gwavm6b">
        <motion.div initial={{
        opacity: 0,
        scale: 0.94
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mx-auto flex aspect-square w-full max-w-[280px] items-center justify-center rounded-full border-8 border-brand-accent/35 bg-brand-cream-light shadow-xl" data-id="element-17" data-mp="7jm558yh9sop">
          <div className="flex h-40 w-40 items-center justify-center rounded-full border border-brand-primary/35 bg-brand-primary/15" data-id="element-18" data-mp="ma384wqrgqnp">
            <HeartHandshakeIcon className="h-16 w-16 text-brand-darker" aria-hidden="true" data-id="element-19" data-mp="v96q1xe6z00m" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-20" data-mp="10803jpthar0s">
          <span className="inline-flex items-center gap-2 rounded-full bg-brand-accent/20 px-4 py-1.5 text-xs font-bold tracking-[0.13em] text-brand-darker uppercase" data-id="element-21" data-mp="agyfxyblinlz">
            <SproutIcon className="h-4 w-4" data-id="element-22" data-mp="6h7hr9jqp57f" /> Mamá sin Caos
          </span>
          <h2 className="mt-4 font-serif text-4xl leading-tight text-brand-darker md:text-5xl" data-id="element-23" data-mp="1hl3cws6dix1">
            Información clara para que no tengas que adivinar en cada toma.
          </h2>
          <div className="mt-6 space-y-4 text-lg leading-relaxed text-brand-darker/75" data-id="element-24" data-mp="u5z0zbfcqd82">
            <p data-id="element-25" data-mp="pcxiktfxrvjq">
              S.O.S. Lactancia está guiado por una asesora certificada de
              lactancia y pensado para acompañarte desde el primer enganche
              hasta el destete.
            </p>
            <p data-id="element-26" data-mp="1hv1ov10kx2b0">
              Reúne protocolos, señales visuales y herramientas prácticas para
              entender qué pasa, decidir con información y pedir ayuda a tiempo
              cuando la necesitás.
            </p>
            <p className="font-serif text-xl italic text-brand-darker" data-id="element-27" data-mp="1w1vagist2hbl">
              “Porque una mamá acompañada puede vivir su lactancia con más
              confianza y menos culpa.”
            </p>
          </div>
          <div className="mt-7 flex flex-wrap gap-x-5 gap-y-3 text-sm font-medium text-brand-darker" data-id="element-28" data-mp="1r925bttfd6yz">
            <a className="inline-flex items-center gap-2 hover:text-brand-accent" href="https://www.instagram.com/mamasiincaos?igsh=dnVnOHZ3M2VhY2hk&utm_source=qr" target="_blank" rel="noopener noreferrer" data-id="element-29" data-mp="1d9aollbixcha">
              <InstagramIcon className="h-4 w-4" data-id="element-30" data-mp="148vym8nm797g" /> @mamasiincaos
            </a>
            <a className="inline-flex items-center gap-2 hover:text-brand-accent" href="mailto:soporte.mamasinkos@gmail.com" data-id="element-31" data-mp="14ayv9bj9w0l5">
              <MailIcon className="h-4 w-4" data-id="element-32" data-mp="2ym402j63ij22" /> soporte.mamasinkos@gmail.com
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}